import React from 'react'

export default function TerminosCondiciones () {
  return (
    <>
      <section id="contact" className="contact">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <h1>Términos y Condiciones</h1>
            </div>
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="content-section">
                <h2>1. Introducción</h2>
                <p>
                  Bienvenido a [Nombre de la Empresa]. Al utilizar nuestros servicios, aceptas los siguientes Términos y Condiciones. Es importante que los leas cuidadosamente antes de utilizar nuestra plataforma.
                </p>
              </div>
            </div>
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="content-section">
                <h2>2. Uso del Servicio</h2>
                <p>
                  El acceso y uso de nuestros servicios está sujeto a tu aceptación de estos términos. Al utilizar nuestro sitio web o nuestras aplicaciones, te comprometes a:
                </p>
                <ul>
                  <li>Usar nuestros servicios solo para fines legales.</li>
                  <li>No realizar actividades que puedan dañar o interferir con el funcionamiento de nuestros servicios.</li>
                  <li>Proporcionar información precisa y veraz en tus registros.</li>
                </ul>
              </div>
            </div>
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="content-section">
                <h2>3. Propiedad Intelectual</h2>
                <p>
                  Todo el contenido disponible en nuestro sitio, como textos, imágenes, logotipos y software, está protegido por derechos de propiedad intelectual. No está permitido reproducir, distribuir o modificar este contenido sin nuestra autorización previa.
                </p>
              </div>
            </div>
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="content-section">
                <h2>4. Limitación de Responsabilidad</h2>
                <p>
                  No seremos responsables por daños indirectos, especiales o incidentales derivados del uso de nuestro servicio. Tampoco garantizamos que el servicio estará disponible en todo momento o que estará libre de errores.
                </p>
              </div>
            </div>
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="content-section">
                <h2>5. Modificaciones</h2>
                <p>
                  Nos reservamos el derecho de modificar estos Términos y Condiciones en cualquier momento. Los cambios serán notificados oportunamente y, si continúas utilizando el servicio, se considerará que aceptas las nuevas condiciones.
                </p>
              </div>
            </div>
            <div
              className="col-lg-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="content-section">
                <h2>6. Ley Aplicable</h2>
                <p>
                  Estos términos se regirán e interpretarán de acuerdo con las leyes de [Jurisdicción].
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
